import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import { filter, findIndex, set } from 'lodash'

import { LabelingState } from '@/stores/slices/Labeling/types'
import { addTag, deleteTag } from '@/stores/slices/Labeling/thunks/clsTag'

export const clsTagExtraReducers = (builder: ActionReducerMapBuilder<LabelingState>) => {
  builder.addCase(addTag.fulfilled, (state, action) => {
    const updatedIndex = findIndex(state.files, (f) => f?._id === action.payload._id)
    set(state.files, `[${[updatedIndex]}].labelingObjects`, action.payload.labelingObjects)
  })
  builder.addCase(deleteTag.fulfilled, (state, action) => {
    const { _id, labelingItemId } = action.payload

    const updatedIndex = findIndex(state.files, (f) => f?._id === labelingItemId)
    set(state.files, `[${[updatedIndex]}].labelingObjects`, filter(state.files[updatedIndex]?.labelingObjects, (o) => o._id !== _id))
  })
}
